export const apiEndpoints = [
  {
    id: 'get-business-profile',
    method: 'POST',
    path: '/api/v2/whatsapp/partner/get-business-profile',
    description: 'Get the business profile information',
    parameters: [
      { name: 'token', type: 'string', required: true, description: 'Partner authentication token' },
      { name: 'phone_id', type: 'string', required: true, description: 'WhatsApp phone number ID' },
      { name: 'business_id', type: 'string', required: true, description: 'WhatsApp Business Account ID' }
    ],
    example: {
      name: 'Get Business Profile',
      curl: `curl -X POST http://localhost:1337/api/v2/whatsapp/partner/get-business-profile \\
  -H "Content-Type: application/json" \\
  -d '{
    "token": "YOUR_PARTNER_TOKEN",
    "phone_id": "YOUR_PHONE_ID",
    "business_id": "YOUR_BUSINESS_ID"
  }'`,
      javascript: `const response = await fetch('http://localhost:1337/api/v2/whatsapp/partner/get-business-profile', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    token: 'YOUR_PARTNER_TOKEN',
    phone_id: 'YOUR_PHONE_ID',
    business_id: 'YOUR_BUSINESS_ID'
  })
});

const data = await response.json();
console.log(data);`
    },
    responses: [
      {
        status: true,
        message: "Fetched Successfully",
        data: {
          about: "Welcome to our business",
          address: "123 Business Street, City",
          description: "Your Trusted Business Partner",
          email: "business@example.com",
          profile_picture_url: "https://example.com/profile-picture.jpg",
          websites: [
            "https://www.example.com"
          ],
          vertical: "RETAIL",
          messaging_product: "whatsapp"
        }
      },
      {
        status: false,
        message: "Invalid token",
        data: null
      },
      {
        status: false,
        message: "Request includes one or more unsupported or misspelled parameters.",
        data: {
          fbtrace_id: "AbCdEfGhIjKlMnOpQrStUv"
        }
      }
    ]
  },
  {
    id: 'get-phone-numbers',
    method: 'POST',
    path: '/api/v2/whatsapp/partner-get-phone-numbers',
    description: 'Get all WhatsApp phone numbers associated with a business account',
    parameters: [
      { name: 'token', type: 'string', required: true, description: 'Partner authentication token' },
      { name: 'whatsapp_business_id', type: 'string', required: true, description: 'WhatsApp Business Account ID' }
    ],
    example: {
      name: 'Get Phone Numbers',
      curl: `curl -X POST http://localhost:1337/api/v2/whatsapp/partner-get-phone-numbers \\
  -H "Content-Type: application/json" \\
  -d '{
    "token": "YOUR_PARTNER_TOKEN",
    "whatsapp_business_id": "YOUR_BUSINESS_ID"
  }'`,
      javascript: `const response = await fetch('http://localhost:1337/api/v2/whatsapp/partner-get-phone-numbers', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    token: 'YOUR_PARTNER_TOKEN',
    whatsapp_business_id: 'YOUR_BUSINESS_ID'
  })
});

const data = await response.json();
console.log(data);`
    },
    responses: [
      {
        status: true,
        message: "Fetched Successfully",
        data: [
          {
            quality_rating: "GREEN",
            display_phone_number: "+1 234-567-8900",
            code_verification_status: "EXPIRED",
            verified_name: "Example Business Name",
            id: "123456789012345"
          }
        ]
      },
      {
        status: false,
        message: "Invalid token",
        data: null
      },
      {
        status: false,
        message: "Request includes one or more unsupported or misspelled parameters.",
        data: {
          fbtrace_id: "AbCdEfGhIjKlMnOpQrStUv"
        }
      }
    ]
  },
  {
    id: 'get-phone-details',
    method: 'POST',
    path: '/api/v2/whatsapp/partner-get-phone-details',
    description: 'Get details of a WhatsApp phone number',
    parameters: [
      { name: 'token', type: 'string', required: true, description: 'Partner authentication token' },
      { name: 'phone_id', type: 'string', required: true, description: 'WhatsApp phone number ID' }
    ],
    example: {
      name: 'Get Phone Details',
      curl: `curl -X POST http://localhost:1337/api/v2/whatsapp/partner-get-phone-details \\
  -H "Content-Type: application/json" \\
  -d '{
    "token": "YOUR_PARTNER_TOKEN",
    "phone_id": "YOUR_PHONE_ID"
  }'`,
      javascript: `const response = await fetch('http://localhost:1337/api/v2/whatsapp/partner-get-phone-details', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    token: 'YOUR_PARTNER_TOKEN',
    phone_id: 'YOUR_PHONE_ID'
  })
});

const data = await response.json();
console.log(data);`
    },
    responses: [
      {
        status: true,
        message: "Fetched Successfully",
        data: {
          verified_name: "Example Business Name",
          code_verification_status: "EXPIRED",
          display_phone_number: "+1 234-567-8900",
          quality_rating: "GREEN",
          platform_type: "CLOUD_API",
          throughput: {
            level: "STANDARD"
          },
          last_onboarded_time: "2024-01-01T00:00:00+0000",
          webhook_configuration: {
            application: "https://example.com/api/whatsapp/webhook"
          },
          id: "123456789012345"
        }
      },
      {
        status: false,
        message: "Invalid token",
        data: null
      },
      {
        status: false,
        message: "Request includes one or more unsupported or misspelled parameters.",
        data: {
          fbtrace_id: "AbCdEfGhIjKlMnOpQrStUv"
        }
      }
    ]
  },
  {
    id: 'get-templates',
    method: 'POST',
    path: '/api/v2/whatsapp/partner-get-phone-templates',
    description: 'Get available WhatsApp templates for a phone number',
    parameters: [
      { name: 'token', type: 'string', required: true, description: 'Partner authentication token' },
      { name: 'phone_id', type: 'string', required: true, description: 'WhatsApp phone number ID' },
      { name: 'whatsapp_business_id', type: 'string', required: true, description: 'WhatsApp Business Account ID' }
    ],
    example: {
      name: 'Get Phone Templates',
      curl: `curl -X POST http://localhost:1337/api/v2/whatsapp/partner-get-phone-templates \\
  -H "Content-Type: application/json" \\
  -d '{
    "token": "YOUR_PARTNER_TOKEN",
    "phone_id": "YOUR_PHONE_ID"
  }'`,
      javascript: `const response = await fetch('http://localhost:1337/api/v2/whatsapp/partner-get-phone-templates', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    token: 'YOUR_PARTNER_TOKEN',
    phone_id: 'YOUR_PHONE_ID'
  })
});

const data = await response.json();
console.log(data);`
    },
    responses: [
      {
        status: true,
        message: "Fetched Successfully",
        data: {
          data: [
            {
              name: "sample_template",
              parameter_format: "POSITIONAL",
              components: [
                {
                  type: "HEADER",
                  format: "TEXT",
                  text: "Special Offer Inside!"
                },
                {
                  type: "BODY",
                  text: "Don't miss out on our exclusive deals. Click here to see all offers."
                },
                {
                  type: "FOOTER",
                  text: "Click the buttons below to manage your notification preferences"
                }
              ],
              language: "en",
              status: "APPROVED",
              category: "MARKETING",
              id: "123456789012345"
            }
          ],
          paging: {
            cursors: {
              before: "QWERTY",
              after: "ASDFGH"
            }
          }
        }
      },
      {
        status: false,
        message: "Invalid token",
        data: null
      },
      {
        status: false,
        message: "Request includes one or more unsupported or misspelled parameters.",
        data: {
          fbtrace_id: "AbCdEfGhIjKlMnOpQrStUv"
        }
      }
    ]
  },
  {
    id: 'send-text',
    method: 'POST',
    path: '/api/v2/whatsapp/partner-send-text-message',
    description: 'Send a WhatsApp text message to a recipient',
    parameters: [
      { name: 'token', type: 'string', required: true, description: 'Partner authentication token' },
      { name: 'phone_id', type: 'string', required: true, description: 'WhatsApp phone number ID' },
      { name: 'to', type: 'string', required: true, description: 'Recipient phone number' },
      { name: 'message', type: 'string', required: true, description: 'Text message to send' }
    ],
    example: {
      name: 'Send Text Message',
      curl: `curl -X POST http://localhost:1337/api/v2/whatsapp/partner-send-text-message \\
  -H "Content-Type: application/json" \\
  -d '{
    "token": "YOUR_PARTNER_TOKEN",
    "phone_id": "YOUR_PHONE_ID",
    "to": "RECIPIENT_PHONE_NUMBER",
    "message": "Hello! This is a test message."
  }'`,
      javascript: `const response = await fetch('http://localhost:1337/api/v2/whatsapp/partner-send-text-message', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    token: 'YOUR_PARTNER_TOKEN',
    phone_id: 'YOUR_PHONE_ID',
    to: 'RECIPIENT_PHONE_NUMBER',
    message: 'Hello! This is a test message.'
  })
});

const data = await response.json();
console.log(data);`
    },
    responses: [
      {
        status: true,
        message: "Fetched Successfully",
        data: [
          {
            id: "wamid.HBgNDExMjIzMzM0NDU1FQIAERgSNDVCNzZFREM5ODc5RUY1RjQyAA=="
          }
        ]
      },
      {
        status: false,
        message: "Invalid token",
        data: null
      },
      {
        status: false,
        message: "Request includes one or more unsupported or misspelled parameters.",
        data: {
          fbtrace_id: "AbCdEfGhIjKlMnOpQrStUv"
        }
      }
    ]
  },
  {
    id: 'send-template',
    method: 'POST',
    path: '/api/v2/whatsapp/partner-send-whatsapp-template',
    description: 'Send a WhatsApp template message to a recipient',
    parameters: [
      { name: 'token', type: 'string', required: true, description: 'Partner authentication token' },
      { name: 'phone_id', type: 'string', required: true, description: 'WhatsApp phone number ID' },
      { name: 'template_name', type: 'string', required: true, description: 'Name of the template to send' },
      { name: 'to', type: 'string', required: true, description: 'Recipient phone number' },
      { name: 'language', type: 'string', required: true, description: 'Template language code' }
    ],
    example: {
      name: 'Send Template Message',
      curl: `curl -X POST http://localhost:1337/api/v2/whatsapp/partner-send-whatsapp-template \\
  -H "Content-Type: application/json" \\
  -d '{
    "token": "YOUR_PARTNER_TOKEN",
    "phone_id": "YOUR_PHONE_ID",
    "template_name": "sample_template",
    "to": "RECIPIENT_PHONE_NUMBER",
    "language": "en"
  }'`,
      javascript: `const response = await fetch('http://localhost:1337/api/v2/whatsapp/partner-send-whatsapp-template', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    token: 'YOUR_PARTNER_TOKEN',
    phone_id: 'YOUR_PHONE_ID',
    template_name: 'sample_template',
    to: 'RECIPIENT_PHONE_NUMBER',
    language: 'en'
  })
});

const data = await response.json();
console.log(data);`
    },
    responses: [
      {
        status: true,
        message: "FetchedSuccessfully",
        data: [
          {
            id: "wamid.HBgNDExMjIzMzM0NDU1FQIAERgSMzNCQzRFNTY3MUJFNTcxMDMxOAA=",
            message_status: "accepted"
          }
        ]
      },
      {
        status: false,
        message: "Invalid token",
        data: null
      },
      {
        status: false,
        message: "Request includes one or more unsupported or misspelled parameters.",
        data: {
          fbtrace_id: "AbCdEfGhIjKlMnOpQrStUv"
        }
      }
    ]
  }
];
